import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { catalogTranslationRef } from '@backstage/plugin-catalog';

export const catalogTranslations = createTranslationResource({
  ref: catalogTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
    en: () => import('./en'),
  },
});
